import PropTypes from 'prop-types';
import React from 'react';
import Datetime from 'react-datetime';
import { connect } from 'react-redux';
import axios from 'helpers/gastro';
// styles
import { combineStyles, isGranted } from 'helpers/helpers';
import { get } from 'helpers/apiHelpers';
// eslint-disable-next-line import/order -- FIXME
import { isDatepickerValidDay } from 'helpers/dateHelpers';

// components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import SelectAll, { ALL_SELECTED_VALUE } from 'components/SelectAll';
import LabeledRadio from 'components/LabeledRadio/LabeledRadio';
import ReportConfigurator from 'components/Report/ReportConfigurator';
import MultiplierCalculator from 'components/MultiplierCalculator/MultiplierCalculator';
import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import { Dialog, DialogContent, RadioGroup, Tooltip } from '@material-ui/core';
import ConditionalWrapper from 'components/ConditionalWrapper/ConditionalWrapper';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import moment from 'moment';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import Cookies from 'cookies-js';
import CardWrapper from 'components/Card/CardWrapper';
import { toast } from 'react-toastify';
import { apiErrorToast } from 'utils/apiError';
import DEFAULT_SALES_MARKET_LANG from 'constants/defaultSalesMarketLang';

import Archive from '../../components/Archive/Archive';
import { fetchZoneCategories } from '../../actions/ZoneCategories';
import roles, {
  ROLE_SHOW_SUB_BRAND,
  ROLE_SHOW_ZONE_CATEGORY,
} from '../../helpers/roles';
import getSelectSubBrandLabel from '../../helpers/getSelectSubBrandLabel';
import DownloadReportButtons from './DownloadReportButtons/DownloadReportButtons';
import MIME_TYPES from './constants/mimeTypes';
import MIME_TYPES_DATA from './constants/mimeTypesData';
import ReportPreview from './ReportPreviev/ReportPreview';
import AccessDenied from '../../components/Security/AccessDenied';
import { FILE_REPORT_MODE } from './constants/fileMode';
import REPORT_SOURCE from './constants/reportSource';

const reportSourceStyle = {
  reportSourceRadioRoot: {
    padding: '4px 16px',
  },
  reportSourceRadioContainer: {
    padding: '16px 0px',
  },
};

const DEFAULT_STATE = () => ({
  mealCategoriesOptions: [],
  subBrandsOptions: [],
  reportSource: REPORT_SOURCE.brands,
  selectedBrands: [],
  selectedSubBrands: [],
  selectedMealCategories: [],
  selectedZoneCategories: [],
  date: '',
  dateFrom: '',
  dateTo: '',
  multiplier: 1,
  isGenerating: false,
  isGeneratingPreview: false,
  multiplierCalculatorOpen: false,
  filePreview: '',
  excelContent: {},
  isReportPreviewOpen: false,
});

class BaseBrandReport extends React.Component {
  // eslint-disable-next-line new-cap -- FIXME
  state = DEFAULT_STATE();

  dateType = Array.isArray(this.props.dateType)
    ? this.props.dateType[0]
    : this.props.dateType;

  dateRangeTexts = () => {
    switch (this.props.dateType[1]) {
      case 'ordered':
        return {
          dateFrom: this.props.t('reports.orderDateFrom'),
          dateTo: this.props.t('reports.orderDateTo'),
        };
      default:
        return {
          dateFrom: this.props.t('reports.deliveryDateFrom'),
          dateTo: this.props.t('reports.deliveryDateTo'),
        };
    }
  };

  componentDidMount = async () => {
    if (
      this.props.useZoneCategories &&
      isGranted(roles.ROLE_SHOW_ZONE_CATEGORY)
    ) {
      await this.props.fetchZoneCategories();
    }
    if (this.props.useMealCategories) {
      const mealCategoriesResponse = await get('/meal-categories');
      await this.setState(prevState => ({
        ...prevState,
        mealCategoriesOptions: mealCategoriesResponse['hydra:member'],
      }));
    }
    if (this.props.useReportSourceSwitch && isGranted(ROLE_SHOW_SUB_BRAND)) {
      await this.fetchSubBrands();
    }
    if (Cookies.get('base_brand_report')) {
      const tmpObject = {
        // eslint-disable-next-line new-cap -- FIXME
        ...DEFAULT_STATE(),
        ...JSON.parse(Cookies.get('base_brand_report')),
        isReportPreviewOpen: false,
        filePreview: '',
        excelContent: {},
      };
      // eslint-disable-next-line no-prototype-builtins -- FIXME
      if (tmpObject.hasOwnProperty('mealCategoriesOptions')) {
        delete tmpObject.mealCategoriesOptions;
      }
      delete tmpObject.subBrandsOptions;
      if (!this.props.useMealCategories) {
        tmpObject.selectedMealCategories = [];
      }
      if (!this.props.useZoneCategories) {
        tmpObject.selectedZoneCategories = [];
      }
      if (
        !this.props.useReportSourceSwitch ||
        !isGranted(ROLE_SHOW_SUB_BRAND)
      ) {
        tmpObject.reportSource = REPORT_SOURCE.brands;
        tmpObject.selectedSubBrands = [];
      }
      this.setState(prevState => ({
        ...prevState,
        ...tmpObject,
      }));
    }
  };

  fetchSubBrands = async () => {
    const response = await get('/sub-brands', { pagination: false });

    this.setState({ subBrandsOptions: response['hydra:member'] });
  };

  isSubBrandSource = () =>
    !!this.props.useReportSourceSwitch &&
    this.state.reportSource === REPORT_SOURCE.subBrands;

  getSelectedSubBrandValues = () =>
    this.state.selectedSubBrands
      .filter(subBrand => subBrand && subBrand.value !== ALL_SELECTED_VALUE)
      .map(subBrand => subBrand.value);

  getSourceSelectWidth = () => {
    const { showMultiplier, useZoneCategories } = this.props;

    if (showMultiplier && useZoneCategories) {
      return 2;
    }

    if (showMultiplier || useZoneCategories) {
      return 4;
    }

    return this.dateType ? 6 : 12;
  };

  handleReportSourceChange = event => {
    const reportSource = event.target.value;

    this.setState(
      reportSource === REPORT_SOURCE.subBrands
        ? { reportSource, selectedBrands: [], selectedZoneCategories: [] }
        : { reportSource, selectedSubBrands: [] }
    );
  };

  getParams = () => ({
    ...(this.isSubBrandSource()
      ? { subBrands: this.getSelectedSubBrandValues() }
      : { brands: this.state.selectedBrands.map(brand => brand.value) }),
    ...(this.props.showMultiplier && {
      multiplier: this.state.multiplier,
    }),
    ...(this.dateType === 'range' && {
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
    }),
    ...(this.dateType === 'single' && {
      date: this.state.date,
    }),
    ...(this.props.useZoneCategories &&
      !this.isSubBrandSource() && {
        zoneCategories: this.state.selectedZoneCategories.map(
          zoneCategory => zoneCategory.value
        ),
      }),
    ...(this.props.useMealCategories && {
      mealCategories: this.state.selectedMealCategories.map(
        mealCategory => mealCategory.value
      ),
    }),
    ...(this.props.additionalParams || {}),
  });

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  validateDate = () => {
    switch (this.dateType) {
      case 'range':
        return !!(this.state.dateFrom && this.state.dateTo);
      case 'single':
        return !!this.state.date;
      default:
        return true;
    }
  };

  validateBrands = () =>
    this.isSubBrandSource()
      ? this.getSelectedSubBrandValues().length !== 0
      : this.state.selectedBrands.length !== 0;

  getRequiredSourceError = brandErrorKey =>
    this.isSubBrandSource()
      ? this.props.t('errors.reportRequireSubBrand')
      : this.props.t(brandErrorKey);

  getFileNameDates = () => {
    switch (this.dateType) {
      case 'range':
        return {
          date: '',
          dateFrom: this.state.dateFrom,
          dateTo: this.state.dateTo,
        };
      case 'single':
        return { date: this.state.date, dateFrom: '', dateTo: '' };
      default:
        return {};
    }
  };

  downloadPdf = () => {
    const link = document.createElement('a');
    link.href = this.state.filePreview;
    link.setAttribute(
      'download',
      `${this.props.fileName(this.getFileNameDates())}.pdf`
    );

    document.body.appendChild(link);
    link.click();
  };

  // eslint-disable-next-line consistent-return -- FIXME
  handlePreviewGenerate = (mimeType, lang, mode) => {
    const { t, pdfUrl, excelUrl } = this.props;
    const isPdfMode = mode === FILE_REPORT_MODE.pdf;

    const requestUrl = isPdfMode ? pdfUrl : excelUrl;

    if (!this.validateDate()) {
      return toast.error(t('reports.sDatePreview'));
    }
    if (!this.validateBrands()) {
      return toast.error(
        this.getRequiredSourceError('errors.raportRequireBrand')
      );
    }

    this.setState({
      isGeneratingPreview: true,
    });

    const handleChangeState = content => {
      this.setState({
        excelContent: isPdfMode ? {} : content,
        filePreview: isPdfMode ? content : '',
        isGeneratingPreview: false,
        isReportPreviewOpen: true,
      });
    };

    axios
      .get(requestUrl, {
        responseType: 'blob',
        headers: { accept: isPdfMode ? mimeType : MIME_TYPES.json },
        forcedLanguage: lang,
        params: this.getParams(),
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        async response => {
          if (response.data) {
            if (isPdfMode) {
              const url = window.URL.createObjectURL(
                new Blob([response.data], { type: mimeType })
              );

              handleChangeState(url);
            } else {
              const text = await response.data.text();
              const excelContent = JSON.parse(text);

              handleChangeState(excelContent);
            }
          } else {
            toast.error(t('reports.noAccess'));
          }
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
        error => {
          apiErrorToast(t('reports.cannotGeneratePreview'), error);
          this.setState({ isGeneratingPreview: false });
        }
      )
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .finally(() => {
        this.setState({ isGeneratingPreview: false });
      });
  };

  // eslint-disable-next-line consistent-return -- FIXME
  handleGenerate = (mimeType, lang) => {
    const { t } = this.props;
    this.setState({ isGenerating: true });
    if (!this.validateDate()) {
      this.setState({ isGenerating: false });
      return toast.error(t('errors.reportRequiresDate'));
    }
    if (!this.validateBrands()) {
      this.setState({ isGenerating: false });
      return toast.error(
        this.getRequiredSourceError('errors.reportRequireBrand')
      );
    }

    const { excelContent, filePreview, subBrandsOptions, ...restState } =
      this.state;
    Cookies.set('base_brand_report', JSON.stringify(restState));

    const config = {
      [MIME_TYPES.csv]: {
        url: this.props.csvUrl || this.props.excelUrl,
        extension: MIME_TYPES_DATA[MIME_TYPES.csv].extension,
      },
      [MIME_TYPES.pdf]: {
        url: this.props.pdfUrl,
        extension: MIME_TYPES_DATA[MIME_TYPES.pdf].extension,
      },
    }[mimeType] || {
      url: this.props.excelUrl,
      extension: MIME_TYPES_DATA[MIME_TYPES.xlsx].extension,
    };

    const fileName = `${this.props.fileName(this.getFileNameDates())}.${
      config.extension
    }`;

    axios
      .get(config.url, {
        responseType: 'blob',
        params: this.getParams(),
        headers: { accept: mimeType },
        forcedLanguage: lang,
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        response => {
          if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);

            document.body.appendChild(link);
            link.click();
            this.setState({ isGenerating: false });
          } else {
            alert(t('reports.noAccess'));
          }
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
        error => {
          apiErrorToast(t('reports.cannotGenerate'), error);
          this.setState({ isGenerating: false });
        }
      )
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .finally(() => {
        this.setState({ isGenerating: false });

        if (this.props.onAfterGenerate) {
          this.props.onAfterGenerate();
        }
      });
  };

  render() {
    const {
      additionalParams,
      archiveReportNames,
      brands,
      children,
      classes,
      company,
      csvAvailable,
      excelAvailable,
      previewXlsxAvailable,
      isSalesMarketLangViewEnabled,
      pdfAvailable,
      reportConfiguration,
      showMultiplier,
      t,
      title,
      useMealCategories,
      useReportSourceSwitch,
      useZoneCategories,
      zoneCategories,
    } = this.props;

    const {
      date,
      dateFrom,
      dateTo,
      excelContent,
      filePreview,
      isGenerating,
      isGeneratingPreview,
      isReportPreviewOpen,
      mealCategoriesOptions,
      multiplier,
      multiplierCalculatorOpen,
      reportSource,
      selectedBrands,
      selectedMealCategories,
      selectedSubBrands,
      selectedZoneCategories,
      subBrandsOptions,
    } = this.state;

    const companyId = parseInt(company.split('/').pop(), 10);
    const reportKey = reportConfiguration?.report || false;
    const fields = reportConfiguration?.fields;
    const isSubBrandSource = this.isSubBrandSource();
    const userHasSubBrandAccess = isGranted(ROLE_SHOW_SUB_BRAND);

    return isGranted(this.props.role) ? (
      <>
        <CardWrapper
          title={
            <>
              {title}{' '}
              {reportKey && (
                <ReportConfigurator
                  companyId={companyId}
                  report={reportKey}
                  fields={fields}
                />
              )}
            </>
          }
          style={{ marginTop: '20px' }}
        >
          <Dialog open={isGenerating || isGeneratingPreview}>
            <DialogContent>
              <div style={{ textAlign: 'center' }}>
                <h1>
                  {isGeneratingPreview
                    ? t('reports.generatePreview.loader')
                    : t('reports.generate')}
                </h1>
                <CircularProgress />
              </div>
            </DialogContent>
          </Dialog>
          <CardBody>
            {useReportSourceSwitch && (
              <GridContainer justify="flex-start">
                <GridItem sm={12}>
                  <FormLabel className={classes.labelHorizontal}>
                    {t('reports.includeInReport')}
                  </FormLabel>
                  <RadioGroup
                    className="input-radio-group--report-source"
                    name="reportSource"
                    value={reportSource}
                    onChange={this.handleReportSourceChange}
                    classes={{ root: classes.reportSourceRadioContainer }}
                  >
                    <LabeledRadio
                      value={REPORT_SOURCE.brands}
                      label={t('reports.reportSource.brands')}
                      classes={{ root: classes.reportSourceRadioRoot }}
                    />
                    <LabeledRadio
                      value={REPORT_SOURCE.subBrands}
                      label={
                        <ConditionalWrapper
                          useWrapper={!userHasSubBrandAccess}
                          renderWrapper={wrapperChildren => (
                            <Tooltip title={t('common.shared.noPermissions')}>
                              <span>{wrapperChildren}</span>
                            </Tooltip>
                          )}
                        >
                          {t('reports.reportSource.subBrands')}
                        </ConditionalWrapper>
                      }
                      classes={{ root: classes.reportSourceRadioRoot }}
                      disabled={!userHasSubBrandAccess}
                    />
                  </RadioGroup>
                </GridItem>
              </GridContainer>
            )}
            <GridContainer justify="flex-start">
              <GridItem
                sm={this.getSourceSelectWidth()}
                data-cy={
                  isSubBrandSource
                    ? 'report-subbrand-select'
                    : 'report-brand-select'
                }
              >
                <FormLabel
                  className={classes.labelHorizontal}
                  style={{
                    textAlign: 'start',
                    width: '100%',
                  }}
                >
                  {isSubBrandSource
                    ? t('reports.selectSubbrands')
                    : t('reports.selectBrands')}{' '}
                  *
                </FormLabel>
                {isSubBrandSource ? (
                  <SelectAll
                    className="input-select--subbrand"
                    options={subBrandsOptions}
                    trackBy="@id"
                    mapBy="name"
                    optionSelected={selectedSubBrands}
                    customLabel={subBrand =>
                      getSelectSubBrandLabel(subBrand, brands)
                    }
                    handleChange={selected => {
                      this.setState({
                        selectedSubBrands: selected,
                      });
                    }}
                  />
                ) : (
                  <SelectAll
                    className="input-select--brand"
                    options={brands}
                    trackBy={['@id']}
                    mapBy="name"
                    optionSelected={selectedBrands}
                    handleChange={selected => {
                      this.setState({
                        selectedBrands: selected,
                      });
                    }}
                  />
                )}
              </GridItem>
              {isGranted(ROLE_SHOW_ZONE_CATEGORY) && useZoneCategories && (
                <GridItem sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    {t('reports.selectZoneCategories')}
                  </FormLabel>
                  <SelectAll
                    className="input-select--zone-category"
                    options={zoneCategories}
                    trackBy="@id"
                    mapBy="name"
                    optionSelected={selectedZoneCategories}
                    isDisabled={isSubBrandSource}
                    handleChange={selected => {
                      this.setState({
                        selectedZoneCategories: selected,
                      });
                    }}
                  />
                </GridItem>
              )}
              {showMultiplier && (
                <GridItem sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    {t('common.multiplier')}
                  </FormLabel>
                  <FormControl fullWidth={true}>
                    <FormTextInput
                      className="input-text--multiplier"
                      classes={classes}
                      name="multiplier"
                      value={multiplier}
                      type="number"
                      handleChange={this.handleChange}
                      inputSize={12}
                      onFocus={() =>
                        this.setState({ multiplierCalculatorOpen: true })
                      }
                      inputRef={node => {
                        this.anchorElement = node;
                      }}
                    />
                    <MultiplierCalculator
                      classes={classes}
                      url="/statistics/ecommerce/bags/day"
                      open={multiplierCalculatorOpen}
                      anchorElement={this.anchorElement}
                      brandIds={selectedBrands}
                      handleChange={(name, value) =>
                        this.handleChange({
                          target: {
                            name,
                            value,
                          },
                        })
                      }
                    />
                  </FormControl>
                </GridItem>
              )}
              {this.dateType === 'range' && (
                <>
                  <GridItem sm={3}>
                    <FormLabel className={classes.labelHorizontal}>
                      {this.dateRangeTexts().dateFrom} *
                    </FormLabel>
                    <FormControl fullWidth={true}>
                      <Datetime
                        className="input-datetime--date-from"
                        isValidDate={isDatepickerValidDay}
                        timeFormat={false}
                        dateFormat={moment.localeData().longDateFormat('L')}
                        closeOnSelect={true}
                        // eslint-disable-next-line new-cap -- FIXME
                        value={new moment(dateFrom)}
                        onChange={e =>
                          this.setState({ dateFrom: e.format('YYYY-MM-DD') })
                        }
                        inputProps={{
                          readOnly: true,
                          'data-cy': 'report-date-from',
                        }}
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem sm={3}>
                    <FormLabel className={classes.labelHorizontal}>
                      {this.dateRangeTexts().dateTo} *
                    </FormLabel>
                    <FormControl fullWidth={true}>
                      <Datetime
                        className="input-datetime--date-to"
                        isValidDate={isDatepickerValidDay}
                        timeFormat={false}
                        dateFormat={moment.localeData().longDateFormat('L')}
                        closeOnSelect={true}
                        // eslint-disable-next-line new-cap -- FIXME
                        value={new moment(dateTo)}
                        onChange={e =>
                          this.setState({ dateTo: e.format('YYYY-MM-DD') })
                        }
                        inputProps={{
                          readOnly: true,
                          'data-cy': 'report-date-to',
                        }}
                      />
                    </FormControl>
                  </GridItem>
                </>
              )}
              {this.dateType === 'single' && (
                <>
                  <GridItem sm={6}>
                    <FormLabel className={classes.labelHorizontal}>
                      {t('reports.selectDate')} *
                    </FormLabel>
                    <FormControl fullWidth={true}>
                      <Datetime
                        className="input-datetime--date"
                        isValidDate={isDatepickerValidDay}
                        timeFormat={false}
                        dateFormat={moment.localeData().longDateFormat('L')}
                        closeOnSelect={true}
                        // eslint-disable-next-line new-cap -- FIXME
                        value={new moment(date)}
                        onChange={e =>
                          this.setState({ date: e.format('YYYY-MM-DD') })
                        }
                        inputProps={{
                          readOnly: true,
                          'data-cy': 'report-date',
                        }}
                      />
                    </FormControl>
                  </GridItem>
                </>
              )}
              {useMealCategories && (
                <GridItem sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    {t('common.mainMenu.mealCategory')}
                  </FormLabel>
                  <SelectAll
                    className="input-select--meal-categories"
                    options={mealCategoriesOptions}
                    trackBy="@id"
                    mapBy="value"
                    optionSelected={selectedMealCategories}
                    handleChange={selected => {
                      this.setState({
                        selectedMealCategories: selected,
                      });
                    }}
                  />
                </GridItem>
              )}
              {children}
            </GridContainer>
            {(pdfAvailable ||
              csvAvailable ||
              excelAvailable ||
              previewXlsxAvailable) && (
              <GridContainer justify="flex-end">
                <GridItem>
                  <DownloadReportButtons
                    isSalesMarketLangViewEnabled={isSalesMarketLangViewEnabled}
                    previewPdfAvailable={pdfAvailable}
                    previewXlsxAvailable={previewXlsxAvailable}
                    mimeTypes={[
                      pdfAvailable && MIME_TYPES.pdf,
                      csvAvailable && MIME_TYPES.csv,
                      excelAvailable && MIME_TYPES.xlsx,
                    ].filter(Boolean)}
                    handlePreviewGenerate={this.handlePreviewGenerate}
                    handleGenerate={this.handleGenerate}
                    areButtonsDisabled={this.state.isGenerating}
                  />
                </GridItem>
              </GridContainer>
            )}
          </CardBody>
        </CardWrapper>
        <Card>
          <CardBody>
            <Archive
              options={{
                brands,
                mealCategories: mealCategoriesOptions,
                subBrands: subBrandsOptions,
                zoneCategories,
              }}
              type={['REPORT']}
              reportName={archiveReportNames}
            />
          </CardBody>
        </Card>
        <ReportPreview
          date={date}
          dateFrom={dateFrom}
          dateTo={dateTo}
          dateType={this.dateType}
          excelContent={excelContent}
          filePreview={filePreview}
          includeShopElements={additionalParams?.includeShopElements}
          includeSubscriptions={additionalParams?.includeSubscriptions}
          isOpen={isReportPreviewOpen}
          multiplier={multiplier}
          packedDate={additionalParams?.packedDate}
          selectedBrands={isSubBrandSource ? [] : selectedBrands}
          selectedMealCategories={selectedMealCategories}
          selectedSubBrands={selectedSubBrands}
          selectedZoneCategories={
            isSubBrandSource ? [] : selectedZoneCategories
          }
          shouldBeConsumedTo={additionalParams?.shouldBeConsumedTo}
          showMultiplier={showMultiplier}
          title={title}
          useSubBrands={isSubBrandSource}
          useZoneCategories={useZoneCategories}
          downloadXls={() =>
            this.handleGenerate(MIME_TYPES.xlsx, DEFAULT_SALES_MARKET_LANG)
          }
          downloadPdf={this.downloadPdf}
          onClose={() => {
            this.setState({ isReportPreviewOpen: false });
          }}
        />
      </>
    ) : (
      <AccessDenied />
    );
  }
}

const combinedStyles = combineStyles(
  extendedFormsStyle,
  buttonsStyle,
  reportSourceStyle
);

const mapDispatchToProps = dispatch => ({
  fetchZoneCategories: () => dispatch(fetchZoneCategories()),
});

const mapStateToProps = state => ({
  brands: state.Auth.user.brands,
  zoneCategories: state.ZoneCategories.zoneCategories,
  company: state.Auth.user.company,
});

BaseBrandReport.defaultProps = {
  isSalesMarketLangViewEnabled: false,
};

BaseBrandReport.propTypes = {
  brands: PropTypes.array,
  zoneCategories: PropTypes.array,
  classes: PropTypes.any,
  archiveReportNames: PropTypes.arrayOf(PropTypes.string),
  fileName: PropTypes.func.isRequired,
  showMultiplier: PropTypes.bool,
  mimeType: PropTypes.string.isRequired,
  title: PropTypes.string,
  dateType: PropTypes.string || PropTypes.arrayOf(PropTypes.string),
  useZoneCategories: PropTypes.bool,
  useMealCategories: PropTypes.bool,
  useReportSourceSwitch: PropTypes.bool,
  url: PropTypes.string.isRequired,
  onAfterGenerate: PropTypes.func,
  isSalesMarketLangViewEnabled: PropTypes.bool,
};

const enhance = compose(
  withStyles(combinedStyles),
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(BaseBrandReport);
